import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

const faqs = [
  {
    question: 'O que é a LawX?',
    answer: 'LawX é uma plataforma de tecnologia jurídica alimentada por diversos tipos de IAs diferentes, que em conjunto ajudam advogados a agilizar seus fluxos de trabalho, criando e analisando documentos de qualquer tipo, através de camadas profundas e etapas selecionadas. Além disso, oferecemos soluções personalizadas com plataformas de IA completa para sua empresa, seja ela jurídica ou não. Nossa suíte de mais de 35 ferramentas cobre tudo, desde análise de contratos até pesquisa de casos.'
  },
  {
    question: 'Como funcionam as ferramentas de IA?',
    answer: 'Nossas ferramentas de IA utilizam algoritmos avançados de aprendizado de máquina treinados com vastos conjuntos de dados jurídicos. Cada ferramenta possui diversas camadas de processamento até chegar na resposta final. Elas podem analisar documentos, extrair informações-chave, identificar padrões e fornecer insights acionáveis. Todo o processamento é feito de forma segura e em conformidade com os padrões legais.'
  },
  {
    question: 'Meus dados estão seguros?',
    answer: 'Absolutamente. Utilizamos criptografia de nível bancário, auditorias de segurança regulares e controles de acesso rigorosos. Seus dados são armazenados em instalações que cumprem as normas vigentes, e nunca compartilhamos ou vendemos suas informações.'
  },
  {
    question: 'Qual suporte a LawX oferece nas ferramentas de IA para os advogados?',
    answer: 'Fornecemos suporte abrangente, incluindo chat no Whatsapp e suporte por e-mail. Clientes empresariais têm gerentes de conta dedicados. Também oferecemos sessões de treinamento regulares e webinars para ajudá-lo a maximizar o potencial da plataforma.'
  },
  {
    question: 'Como a LawX se diferencia das demais ferramentas de IA no setor jurídico?',
    answer: 'A LawX é a única solução de IA desenvolvida com base no feedback de mais de 50.000 advogados, assegurando que suas funcionalidades atendam de maneira precisa às demandas práticas do mercado jurídico brasileiro.'
  },
  {
    question: 'A LawX tem a capacidade de substituir advogados?',
    answer: 'Não, a LawX foi concebida para atuar como uma ferramenta complementar, auxiliando os advogados em suas atividades diárias e permitindo que se dediquem a tarefas mais complexas e estratégicas.'
  },
  {
    question: 'Como iniciar o uso da LawX?',
    answer: 'Para iniciar o uso da LawX, basta clicar em "Teste grátis" aqui na página. A plataforma é intuitiva e de fácil utilização, proporcionando uma rápida familiarização com suas funcionalidades.'
  },
  {
    question: 'Há um período de teste gratuito disponível?',
    answer: 'Sim, a LawX disponibiliza um período de teste gratuito, permitindo que os advogados explorem suas ferramentas e avaliem os benefícios antes de optar por uma assinatura paga.'
  },
  {
    question: 'O que é a LawX: Inteligência Artificial para Advogados?',
    answer: 'A LawX é uma plataforma avançada de inteligência artificial criada especificamente para advogados, com o objetivo de otimizar o trabalho jurídico por meio da automação inteligente de processos e análise detalhada de documentos e casos, aumentando a produtividade e precisão na rotina jurídica.'
  },
  {
    question: 'Como usar IA jurídico e como funcionam as ferramentas de IA para advogados?',
    answer: 'A inteligência artificial jurídica da LawX funciona automatizando tarefas rotineiras e repetitivas, analisando processos, gerando documentos e sugerindo estratégias jurídicas. Os advogados podem acessar facilmente a plataforma, inserir informações relevantes sobre seus casos e obter insights valiosos para tomada de decisão rápida e precisa.'
  },
  {
    question: 'O que é a Ferramenta LawX para o setor Jurídico AI?',
    answer: 'A Ferramenta LawX é uma solução que utiliza inteligência artificial avançada para otimizar processos no setor jurídico. Ela oferece automação de tarefas repetitivas, análise inteligente de documentos, gestão eficiente de processos e geração automatizada de peças jurídicas, auxiliando os advogados em suas rotinas diárias.'
  },
  {
    question: 'Qual a melhor IA para jurídico?',
    answer: 'A LawX é considerada a melhor IA para o setor jurídico devido à sua capacidade de integração, facilidade de uso, eficiência na automação de processos jurídicos e constante inovação tecnológica, que assegura alta precisão e resultados eficazes para advogados de todos os perfis e especialidades.'
  },
  {
    question: 'Qual a IA mais usada no Direito?',
    answer: 'A LawX é uma das inteligências artificiais mais utilizadas no setor jurídico, reconhecida por sua eficiência em automatizar e otimizar as tarefas jurídicas, proporcionando grande economia de tempo e melhoria na qualidade das entregas para advogados.'
  },
  {
    question: 'Como a LawX se diferencia das demais ferramentas de IA no setor jurídico?',
    answer: 'A LawX destaca-se das demais ferramentas pela sua especialização profunda em Direito, pela interface intuitiva e amigável, e por funcionalidades avançadas, como automação inteligente, análise preditiva robusta e suporte constante. Além disso, oferece uma experiência de uso simplificada que permite aos advogados de qualquer área aproveitarem plenamente suas funcionalidades.'
  },
  {
    question: 'A LawX tem a capacidade de substituir advogados?',
    answer: 'Não, a LawX não substitui advogados. Seu objetivo é complementar o trabalho dos profissionais, automatizando tarefas repetitivas e permitindo que advogados se concentrem em atividades estratégicas e complexas, agregando valor ao serviço jurídico prestado.'
  },
  {
    question: 'Como começar a usar a LawX?',
    answer: 'Para começar a utilizar a LawX, basta acessar o site da plataforma, criar uma conta gratuita e explorar as funcionalidades oferecidas. A plataforma é intuitiva, permitindo que advogados experimentem facilmente os recursos antes de optar por um plano pago.'
  },
  {
    question: 'A LawX oferece um período de teste gratuito?',
    answer: 'Sim, a LawX oferece um período de teste gratuito, permitindo que os advogados explorem todas as suas funcionalidades e avaliem a efetividade das ferramentas sem qualquer compromisso financeiro inicial.'
  }
];


interface FaqItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onClick: () => void;
}

function FaqItem({ question, answer, isOpen, onClick }: FaqItemProps) {
  return (
    <div className="border-b border-white/10">
      <button
        className="w-full py-6 flex items-center justify-between text-left"
        onClick={onClick}
      >
        <span className="text-lg font-semibold">{question}</span>
        <ChevronDown className={`w-5 h-5 transition-transform ${isOpen ? 'rotate-180' : ''}`} />
      </button>
      <div
        className={`overflow-hidden transition-all duration-300 ${
          isOpen ? 'max-h-96 pb-6' : 'max-h-0'
        }`}
      >
        <p className="text-gray-300">{answer}</p>
      </div>
    </div>
  );
}

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  return (
    <section className="py-16 relative overflow-hidden" id="faq">
      {/* Background accent */}
      <div className="absolute -right-40 bottom-0 w-[400px] h-[400px] rounded-full bg-[#6942E2] opacity-20 blur-3xl" />
      
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            Perguntas Frequentes
          </h2>
          <p className="text-xl text-gray-300">
            Tudo que você precisa saber sobre a LawX
          </p>
        </div>

        <div className="max-w-3xl mx-auto backdrop-blur-lg bg-white/5 rounded-lg p-8 border border-white/10">
          {faqs.map((faq, index) => (
            <FaqItem
              key={index}
              question={faq.question}
              answer={faq.answer}
              isOpen={index === openIndex}
              onClick={() => setOpenIndex(index === openIndex ? -1 : index)}
            />
          ))}
        </div>
      </div>
    </section>
  );
}